import {Indexation} from '@store/settings/indexation/indexation.model';
import {withEntities} from '@ngneat/elf-entities';
import {withPagination} from '@ngneat/elf-pagination';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {createStore} from '@ngneat/elf';

export const indexationStore = createStore(
  { name: 'indexation' },
  withEntities<Indexation>(),
  withPagination(),
  withRequestsStatus(),
);
